// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1YTw4","icon":"SortAdornment_icon__29rRX","up":"SortAdornment_up__3W5st","down":"SortAdornment_down__2GLsC","active":"SortAdornment_active__30jB1"};